import { useTranslation } from 'react-i18next';

import { useFormik } from 'formik';

import {
  isActivityTypeSubmitBlocked,
  resolveActivityTypeIdForSubmit,
  useTrainingActivityTypePicker,
  useTrainingActivityTypePreselect,
} from '../../../hooks/use-training-activity-type-picker';
import { usePostPutTraining } from '../../../redux/api/trainingsAPI';
import { ITraining } from '../../../types/interfaces/training';
import { getTrainingFormValidation } from './FormikData';

export function useEditTrainingModal(
  training: ITraining,
  onCancel: () => void,
  finishDateEditable = false,
) {
  const { t } = useTranslation();
  const [postPutTraining, { isLoading }] = usePostPutTraining();

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: getTrainingFormValidation(t),
    initialValues: {
      title: training?.title || '',
      description: training?.description || '',
      comment: training?.comment || '',
      startDate: training?.startDate || null,
      finishDate: finishDateEditable ? training?.finishDate || null : undefined,
      activityTypeId: training?.activityTypeId ?? null,
    },
    onSubmit,
  });

  useTrainingActivityTypePreselect(formik);

  const {
    activityTypes,
    isLoading: isActivityTypesLoading,
    isError: isActivityTypesError,
    defaultActivityTypeId,
  } = useTrainingActivityTypePicker();

  const isSubmitDisabled = isActivityTypeSubmitBlocked(
    isActivityTypesLoading,
    activityTypes,
    formik.values.activityTypeId,
    defaultActivityTypeId,
    isActivityTypesError,
  );

  function onSubmit(values) {
    return postPutTraining({
      id: training.id,
      body: {
        ...values,
        activityTypeId: resolveActivityTypeIdForSubmit(
          values.activityTypeId,
          defaultActivityTypeId,
          activityTypes,
        ),
      },
    })
      .unwrap()
      .then((response) => {
        onCancel();
      })
      .catch((error) => console.log(error));
  }

  return { formik, isLoading, isSubmitDisabled };
}
